import React, { useState } from 'react';
import { TESTIDS } from '@/lib/testIds';
import { Menu, X } from 'lucide-react';

const LOGO_URL = '/images/logo.png';

const links = [
  { id: 'home', label: 'Home', tid: TESTIDS.header.navHome },
  { id: 'about', label: 'About', tid: TESTIDS.header.navAbout },
  { id: 'book', label: 'The Book', tid: TESTIDS.header.navBook },
  { id: 'resources', label: 'Resources', tid: TESTIDS.header.navResources },
  { id: 'contact', label: 'Contact', tid: TESTIDS.header.navContact },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header className="sticky top-0 z-50 bg-[#FBF7F2]/85 backdrop-blur-md border-b border-[#24385C]/5">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-10 py-3">
        <button
          data-testid={TESTIDS.header.logo}
          onClick={() => scrollTo('home')}
          className="flex items-center gap-3 group"
        >
          <img src={LOGO_URL} alt="Erica Thayer" className="h-14 w-14 md:h-16 md:w-16 object-contain" />
          <div className="hidden sm:block text-left leading-tight">
            <div className="font-heading text-xl text-[#24385C] font-semibold">Erica Thayer</div>
            <div className="font-accent text-[#8D68B2] text-lg -mt-1">Stories for Growing Hearts</div>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.tid}
              onClick={() => scrollTo(l.id)}
              className="text-[#24385C] font-body font-semibold text-[15px] hover:text-[#8D68B2] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-0.5 w-0 bg-[#F5C857] group-hover:w-full transition-all duration-300"></span>
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid={TESTIDS.header.cta}
            href="#book"
            onClick={(e) => { e.preventDefault(); scrollTo('book'); }}
            className="hidden md:inline-flex items-center bg-[#8D68B2] hover:bg-[#24385C] text-white rounded-full px-6 py-2.5 font-body font-semibold text-sm transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5"
          >
            Buy the Book
          </a>
          <button
            data-testid={TESTIDS.header.mobileToggle}
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 rounded-full text-[#24385C] hover:bg-white/70"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FBF7F2] border-t border-[#24385C]/5">
          <div className="max-w-7xl mx-auto px-5 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollTo(l.id)}
                className="text-left text-[#24385C] font-body font-semibold py-2 hover:text-[#8D68B2]"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
